var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.356,
    height: 23.627,
    viewBox: "0 0 21.356 23.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(12906.016 -11184.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    transform: "translate(-12890.654 11184.549)",
    fill: "#2197ed",
    stroke: "rgba(33,151,237,0.35)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.995,
    height: 23.626,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.995,
    height: 22.626,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    transform: "translate(-12906.016 11199.049)",
    fill: "#2197ed",
    stroke: "rgba(33,151,237,0.35)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.995,
    height: 9.127,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.995,
    height: 8.127,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    transform: "translate(-12898.272 11191.922)",
    fill: "#2197ed",
    stroke: "rgba(33,151,237,0.35)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.995,
    height: 16.253,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.995,
    height: 15.253,
    rx: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBars);
export default __webpack_public_path__ + "static/media/threeBars.074016eadba623b7fa9011322df1bce6.svg";
export { ForwardRef as ReactComponent };